// extracted by mini-css-extract-plugin
export default {"loading":"q8dAa","centered":"O08Q5","inner":"Bl2SP"};